import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'csl-radio-tab',
  standalone: true,
  imports: [NgClass, NgTemplateOutlet],
  templateUrl: './radio-tab.component.html',
  styleUrl: './radio-tab.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioTabComponent {
  @Input() public label: string | number = '';
  @Input() public selected = false;
  @Input() public isDisabled = false;
  @Input() public template: TemplateRef<any> | null = null;
}
